import { render, staticRenderFns } from "./HelloComponent.vue?vue&type=template&id=4315f37d&"
import script from "./HelloComponent.vue?vue&type=script&lang=js&"
export * from "./HelloComponent.vue?vue&type=script&lang=js&"
import style0 from "./HelloComponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports